import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6861bf66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lms-lesson" }
const _hoisted_2 = {
  key: 0,
  class: "loading-screen"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "completed-screen"
}
const _hoisted_6 = { class: "completed-card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "completed-screen__icon" }, "✓", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Lektion abgeschlossen!", -1))
const _hoisted_9 = { class: "completed-actions" }
const _hoisted_10 = {
  key: 2,
  class: "completed-screen"
}
const _hoisted_11 = { class: "completed-card" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "completed-screen__icon completed-screen__icon--failed" }, "✕", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Leider nicht bestanden", -1))
const _hoisted_14 = { class: "completed-actions" }
const _hoisted_15 = {
  key: 3,
  class: "player-wrapper"
}
const _hoisted_16 = { class: "lesson-bar" }
const _hoisted_17 = { class: "lesson-bar__inner" }
const _hoisted_18 = { class: "lesson-bar__title" }
const _hoisted_19 = {
  class: "iframe-container",
  ref: "iframeContainer"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "loading-screen"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "no-scorm"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Für diese Lektion ist noch kein SCORM-Paket hinterlegt.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.lesson && !_ctx.isFallback)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.isCompleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("p", null, [
                _createTextVNode(" Sie haben "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.lesson ? _ctx.lesson.title : _ctx.module && _ctx.module.title), 1),
                _createTextVNode(" erfolgreich abgeschlossen. ")
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn-outline-action",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restartLesson && _ctx.restartLesson(...args)))
                }, " Nochmals ansehen "),
                _createElementVNode("button", {
                  class: "btn-primary-action",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backToModule && _ctx.backToModule(...args)))
                }, " Zurück zur Kursübersicht ")
              ])
            ])
          ]))
        : (_ctx.isFailed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("p", null, [
                  _createTextVNode(" Sie haben die maximale Anzahl an Versuchen für "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.lesson ? _ctx.lesson.title : _ctx.module && _ctx.module.title), 1),
                  _createTextVNode(" erreicht. Setzen Sie die Lektion zurück, um sie von vorne zu beginnen. ")
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "btn-outline-action",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backToModule && _ctx.backToModule(...args)))
                  }, " Zurück zur Kursübersicht "),
                  _createElementVNode("button", {
                    class: "btn-primary-action",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.restartFromScratch && _ctx.restartFromScratch(...args)))
                  }, " Lektion von vorne beginnen ")
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "lesson-bar__back",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.backToModule && _ctx.backToModule(...args)))
                  }, "← Kursübersicht"),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.lesson ? _ctx.lesson.title : (_ctx.module && _ctx.module.title)), 1),
                  (_ctx.liveFailed)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "lesson-bar__restart",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.restartFromScratch && _ctx.restartFromScratch(...args)))
                      }, " Lektion von vorne beginnen "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_ctx.scormPath && _ctx.ready)
                  ? (_openBlock(), _createElementBlock("iframe", {
                      key: _ctx.playerSession,
                      src: _ctx.scormPath,
                      frameborder: "0",
                      allow: "autoplay; fullscreen",
                      class: "course-iframe",
                      onLoad: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoad && _ctx.onIframeLoad(...args))),
                      ref: "courseIframe"
                    }, null, 40, _hoisted_20))
                  : (_ctx.scormPath)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("button", {
                          class: "btn-outline-action",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.backToModule && _ctx.backToModule(...args)))
                        }, "Zurück zur Kursübersicht")
                      ]))
              ], 512)
            ]))
  ]))
}